define('app-ProductInfoBox/settings',[],function () {
    return {
        container: '.productInfoBox',
        priceButton: '.pricebutton',
        insuranceText: '.insuranceDiscountTxt'
    };
});
